module.exports = __webpack_public_path__ + "assets/cow.e45ac76c.svg";